import React from 'react'
import { useHistory } from 'react-router'

// utils
import { createJobDayCards } from './CrewMembersForJobDay.collection.utils'

// components
import FourSectionCardListItem from '../../../../../components/collections/FourSectionCardListItem/FourSectionCardListItem.component'

export default function CrewMembersForJobDay({ data, loading, error, id }) {
    const history = useHistory()
    let cards = []
    if(data && data.jobDay) {
        cards = [...createJobDayCards(data.jobDay)]
    }    

    return (<div className='crew-members-for-job-day'>

        {
            cards.map(card => {
                return (<FourSectionCardListItem 
                    mainTitle={`${card.firstName} ${card.lastName}`}
                    subTitle={card.phone}
                    leftData={[card.classification]}
                    rightData={null}
                    onClick={() => history.push(`/schedule/replace-crew-member/${id}`)} 
                />)
            })
        }
        
    </div>)
}